export default __webpack_public_path__ + "static/media/pipesembossing.8b99628c.png";